import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import "./Navbar.css";
import userIcon from "../../assets/user-icon.png";
import { buildApiUrl } from "../../lib/api";

function Navbar({
    isLoggedIn,
    setIsLoggedIn,
    onOpenAccount,
    onOpenLogin,
    onNavigateAccount,
    onNavigateDashboard,
    onNavigateResearch,
    onNavigateEngineering,
    onLogoutMessage,
    currentUser,
}) {
    const [showDropdown, setShowDropdown] = useState(false);
    const dropdownRef = useRef(null);

    useEffect(() => {
        const verify = async () => {
            try {
                const { data } = await axios.get(buildApiUrl("/is_logged_in"), {
                    withCredentials: true,
                });
                if (!data.logged_in) {
                    localStorage.removeItem("isLoggedIn");
                    localStorage.removeItem("email");
                }
                setIsLoggedIn(data.logged_in);
            } catch {
                // Keep existing local state during backend hiccups.
            }
        };
        verify();
    }, [setIsLoggedIn]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowDropdown(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const handleLogout = async () => {
        try {
            await axios.post(buildApiUrl("/auth/logout"), {}, { withCredentials: true });
        } finally {
            setIsLoggedIn(false);
            setShowDropdown(false);
            localStorage.removeItem("isLoggedIn");
            localStorage.removeItem("email");
            localStorage.removeItem("savvy_active_view");
            onLogoutMessage?.("Until next time");
        }
    };

    return (
        <nav className="navbar">
            <div className="navbar-logo">
                <a
                    href="/"
                    className="logo-link"
                    onClick={(e) => {
                        e.preventDefault();
                        window.scrollTo({ top: 0, behavior: "instant" });
                        onNavigateAccount?.();
                    }}
                >
                    <div className="face">
                        <div className="logo-mark">
                            <div className="eyes">
                                <div className="facetext">sa</div>
                                <div className="eye left-eye">V</div>
                                <div className="eye right-eye">V</div>
                                <div className="facetext">y</div>
                            </div>
                            <div className="mouth"></div>
                        </div>
                        <div className="broker">Broker</div>
                    </div>
                </a>
            </div>

            {isLoggedIn ? (
                <div className="navbar-actions navbar-actions-authenticated">
                    <div className="nav-user" ref={dropdownRef}>
                        <button
                            type="button"
                            className="nav-icon-button"
                            onClick={() => setShowDropdown((prev) => !prev)}
                            aria-label="Open account menu"
                        >
                            <img src={userIcon} alt="User" className="user-icon" />
                        </button>

                        {showDropdown ? (
                            <div className="user-dropdown-panel">
                                <button type="button" onClick={() => { setShowDropdown(false); onNavigateAccount?.(); }}>
                                    Account
                                </button>
                                <button type="button" onClick={() => { setShowDropdown(false); onNavigateDashboard?.(); }}>
                                    Trader Dashboard
                                </button>
                                {currentUser?.is_local_admin && (
                                    <>
                                        <button
                                            type="button"
                                            onClick={() => { setShowDropdown(false); onNavigateResearch?.(); }}
                                            style={{ borderTop: "1px solid rgba(159,234,232,0.15)", color: "rgba(159,234,232,0.85)" }}
                                        >
                                            Research Dashboard
                                        </button>
                                        <button
                                            type="button"
                                            onClick={() => { setShowDropdown(false); onNavigateEngineering?.(); }}
                                            style={{ color: "rgba(159,234,232,0.85)" }}
                                        >
                                            Engineering Dashboard
                                        </button>
                                    </>
                                )}
                                <button type="button" onClick={handleLogout}>
                                    Log out
                                </button>
                            </div>
                        ) : null}
                    </div>
                </div>
            ) : (
                <div className="navbar-actions">
                    <button
                        type="button"
                        className="nav-cta nav-cta-primary"
                        onClick={onOpenAccount}
                    >
                        Open account
                    </button>
                    <button
                        type="button"
                        className="nav-cta nav-cta-text"
                        onClick={onOpenLogin}
                    >
                        Log in
                    </button>
                </div>
            )}
        </nav>
    );
}

export default Navbar;
